import React, { useState } from "react";
import { Search, X } from "lucide-react";
import { useDispatch } from "react-redux";
import { ACCOUNT, INBOX, REQUEST } from "utils/reducers";
import { setSearchQuery } from "utils/actions";

interface SearchbarProps {
  searchPatients?: (query: string) => Promise<void>;
  onClearSearch?: () => void;
}

function Searchbar({ searchPatients, onClearSearch }: SearchbarProps) {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");
  const [searchActive, setSearchActive] = useState(false);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  };

  const handleSearch = () => {
    if (searchValue === "") return;
    dispatch({ type: INBOX.search_inbox });
    dispatch(setSearchQuery(searchValue));
    dispatch({ type: REQUEST.hide });
    dispatch({ type: ACCOUNT.hide });
    setSearchActive(true);

    // Call the search function if provided
    if (searchPatients) {
      searchPatients(searchValue);
    }
  };

  const handleClear = () => {
    dispatch({ type: INBOX.current_user_inbox });
    setSearchActive(false);
    setSearchValue("");

    // Call the clear search function to reload normal data
    if (onClearSearch) {
      onClearSearch();
    }
  };

  return (
    <div className="relative w-full">
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-5 flex items-center">
          <button
            onClick={handleSearch}
            className="text-gray-400 hover:text-brand focus:outline-none transition-colors duration-200 p-1 rounded-full hover:bg-gray-100"
          >
            <Search className="h-5 w-5" />
          </button>
        </div>
        <input
          type="text"
          className="block w-full pl-12 pr-12 py-2 md:py-3 rounded-full bg-gray-200 hover:bg-white focus:bg-white focus:outline-none focus:ring-2 focus:ring-brand focus:border-brand placeholder-gray-500 text-base transition-all duration-200 shadow-sm hover:shadow-md"
          placeholder="Search patients..."
          value={searchValue}
          onChange={handleInputChange}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSearch();
          }}
        />
        <div className="absolute inset-y-0 right-0 pr-5 flex items-center">
          {(searchActive || searchValue.length > 0) && (
            <button
              onClick={handleClear}
              className="text-gray-400 hover:text-gray-600 focus:outline-none transition-colors duration-200 p-1 rounded-full hover:bg-gray-100"
            >
              <X className="h-5 w-5" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Searchbar;
